import { useQuery } from "@tanstack/react-query";
import api from "apis";
import { GetLatestWorkParams } from "apis/data-contracts";

const useLatestWorkQuery = () => {
  const query: GetLatestWorkParams = {
    page: 0,
    size: 8,
  };

  return useQuery({
    queryKey: api.dashboard.getLatestWorkKey(query),
    queryFn: () => api.dashboard.getLatestWork(query),
    select: (res) => res.data.result,
  });
};

export default useLatestWorkQuery;
